import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { RoutingContextService } from '@x/ecommerce-shop/app/core/routing/routing-context.service';
import { SubscriberFetch } from '@x/ecommerce-shop/app/subscriber-checkout/state/subscriber.actions';
import { SubscriberState } from '@x/ecommerce-shop/app/subscriber-checkout/state/subscriber.state';
import { IShopSubscriber } from '@x/ecommerce/shop-client';
import { of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

export const subscriberResolver: ResolveFn<IShopSubscriber | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const subscriberVarientId: number = Number(route.params.subscriberVarientId);
  const store = inject(Store);
  const router = inject(Router);
  const rc = inject(RoutingContextService);

  const backtoShop = () => router.navigate([rc.redirectUrl]);

  return store.dispatch(new SubscriberFetch(subscriberVarientId)).pipe(
    switchMap(() => store.selectOnce(SubscriberState.subscriber)),
    tap(async (subscriber) => {
      if (subscriber) return;
      backtoShop();
    }),
    catchError(() => {
      backtoShop();
      return of(null);
    }),
  );
};
